import React from 'react'
import './Spritual_stay_card.css'
import { Link } from 'react-router-dom'
import { encodeId } from '../../../../utils/common'

const Spritual_stay_card = ({ id, image, name, price, isBooked }) => {
    return (
        <>
            <section className='Spritual_stay_card'>

                {/* BOOKED STRIP */}
                {/* {isBooked &&
                    <div className="booked_strip">
                        BOOKED
                    </div>
                } */}
                <div className='imdiv'>
                    <img className='roomimg' src={image} alt="roomimg" />
                </div>

                <div className='contdiv'>
                    <p className='acroom'>{name || ""}</p>
                    <p className='prise'>Price: ₹<span>{price || "0"}</span></p>


                    <Link to={`/guest-house-details/${encodeId(id)}`}>
                        <button className='details_btn zoom_in_out'>Details</button>
                    </Link>

                </div>

            </section>
        </>
    )
}

export default Spritual_stay_card